import { atom } from "recoil";

import { ServiceEstimate } from "types/models";

export const serviceEstimateListState = atom<ServiceEstimate[] | null>({
  key: "serviceEstimateListState",
  default: null,
});
